<template>
  <div>
    <Slider
      :banner="
        `https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact.jpg`
      "
    >
      <div class="row align-items-center">
        <div class="col fontsiyuanmedium">
          <div class="slider-title fontsiyuanmedium">
            {{ $t("slidertitle") }}
          </div>
          <div class="slider-subtitle fontsiyuanregular">
            {{ $t("slidersubtitle") }}
          </div>
        </div>
      </div>
    </Slider>

    <div v-if="isRouterAlive" class="contact-head-container w-100">
      <b-container>
        <b-row class="justify-content-md-center contact-head">
          <b-col cols="4" sm="4" md="4" lgt="3" @click="gotoView('z')">
            <img
              class="head-icon"
              src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact-02.svg"
            />
            <div>{{ $t("topt2text") }}</div>
          </b-col>
          <b-col cols="4" sm="4" md="4" lgt="3" @click="gotoView('j')">
            <img
              class="head-icon"
              src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact-03.svg"
            />
            <div>{{ $t("topt3text") }}</div>
          </b-col>
          <b-col cols="4" sm="4" md="4" lgt="3" @click="gotoView('c')">
            <img
              class="head-icon"
              src="https://demo-1251664918.cos.ap-shanghai.myqcloud.com/contact-02.svg"
            />
            <div>{{ $t("topt1text") }}</div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div>
      <b-container>
        <!-- 采购 -->
        <div id="contact-z" class="contact-item">
          <div class="item-head-container">
            <span class="item-head">
              <img
                class="item-icon"
                src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact-02.svg"
              /><span class="item-title">{{ $t("topt2text") }}</span>
            </span>
          </div>
          <div class="row contact-row" style="justify-content: flex-start">
            <div
              :class="`col-lg-4 col-md-6 col-sm-12 contact-col`"
              v-for="(item, index) in JSON.parse($t('contacttopt1list'))"
              v-bind:key="index"
            >
              <div class="item-info-title">{{ item[0] }}</div>
              <div class="item-info-subtitle mt-3">{{ item[1] }}</div>
              <div class="item-info mt-2">{{ item[2] }}</div>
              <div class="item-info mt-2">{{ item[3] }}</div>
              <div class="item-info mt-2">{{ item[4] }}</div>
              <div class="item-info mt-2">{{ item[5] }}</div>
            </div>
          </div>
        </div>
        <!-- 咨询 -->
        <!-- <div id="contact-z" class="contact-item">
          <div class="item-head-container">
            <span class="item-head">
              <img
                class="item-icon"
                src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact-02.svg"
              /><span class="item-title">{{ $t("topt2text") }}</span>
            </span>
          </div>
          <div class="row contact-row">
            <div
              :class="`col-lg-4 col-md-6 col-sm-12 contact-col`"
              v-for="(item, index) in JSON.parse($t('contacttopt2list'))"
              v-bind:key="index"
            >
              <div class="item-info-title">{{ item[0] }}</div>
              <div class="item-info mt-3">{{ item[1] }}</div>
              <div class="item-info mt-2">{{ item[2] }}</div>
              <div class="item-info mt-2">{{ item[3] }}</div>
              <div class="item-info mt-2">{{ item[4] }}</div>
            </div>
          </div>
        </div> -->
        <!-- 技术支持 -->
        <div id="contact-j" class="contact-item">
          <div class="item-head-container">
            <span class="item-head">
              <img
                class="item-icon"
                src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact-03.svg"
              /><span class="item-title">{{ $t("topt3text") }}</span>
            </span>
          </div>
          <div class="row contact-row" style="justify-content: flex-start">
            <div
              :class="`col-lg-4 col-md-6 col-sm-12 contact-col`"
              v-for="(item, index) in JSON.parse($t('contacttopt3list'))"
              v-bind:key="index"
            >
              <div class="item-info-title">{{ item[0] }}</div>
              <div class="item-info mt-3">{{ item[1] }}</div>
              <div class="item-info mt-2">{{ item[2] }}</div>
              <div class="item-info-active mt-2" @click="contactView()">
                {{ item[3]
                }}<span style="margin-left: 10px; color: #c00f31">&gt;</span>
              </div>
            </div>
          </div>
        </div>

        <div id="contact-c" class="contact-bottom-container w-100">
          <b-container>
            <b-row class="justify-content-md-center contact-head">
              <b-col
                cols="12"
                sm="4"
                md="4"
                lgt="3"
                @click="gotoUrl($t('bottomt1url'))"
              >
                <img
                  class="head-icon"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact2-01.svg"
                />
                <div class="bottom-font">{{ $t("bottomt1text") }}</div>
              </b-col>
              <b-col
                cols="12"
                sm="4"
                md="4"
                lgt="3"
                @click="gotoUrl($t('bottomt2url'))"
              >
                <img
                  class="head-icon"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact2-02.svg"
                />
                <div class="bottom-font">{{ $t("bottomt2text") }}</div>
              </b-col>
              <b-col
                cols="12"
                sm="4"
                md="4"
                lgt="3"
                @click="gotoUrl($t('bottomt3url'))"
              >
                <img
                  class="head-icon"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/contact2-03.svg"
                />
                <div class="bottom-font">{{ $t("bottomt3text") }}</div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-container>
    </div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
  },
  watch: {
    $route() {
      this.$router.go(0);
    },
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      const _this = this;
      this.$nextTick(function() {
        switch (_this.$route.query.p) {
          case "c":
            console.log("c");
            document.getElementById("contact-c").scrollIntoView();
            break;
          case "z":
            console.log("z");
            document.getElementById("contact-z").scrollIntoView();
            break;
          case "j":
            console.log("j");
            document.getElementById("contact-j").scrollIntoView();
            break;
        }
      });
    },
    reload2() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    contactView() {
      window.location.href =
        "http://wpa.qq.com/msgrd?v=3&uin=75965375&site=qq&menu=yes";
    },
    gotoView(v) {
      switch (v) {
        case "c":
          console.log("c");
          document.getElementById("contact-c").scrollIntoView();
          break;
        case "z":
          console.log("z");
          document.getElementById("contact-z").scrollIntoView();
          break;
        case "j":
          console.log("j");
          document.getElementById("contact-j").scrollIntoView();
          break;
      }
    },
    gotoUrl(v) {
      window.location.href = v;
    },
    getContact() {
      const _this = this;
      this.$store.dispatch("getContact").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload2();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
  },
  updated() {
    this.reload();
  },
  mounted() {
    this.reload();
    this.getContact();
  },
};
</script>
<style>
.slider-title {
  margin-left: 115px;
  color: #000;
  font-size: 42px;
  font-weight: bold;
}
.slider-subtitle {
  margin-left: 115px;
  color: #000;
  font-size: 20px;
  font-weight: 100;
}
@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.contact-head {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
}
.contact-head-container {
  border-bottom: 0.5px #c0c4c866 solid;
}
.head-icon {
  width: 60px;
}
.item-icon {
  height: 35px;
  margin-bottom: 10px;
}
.item-title {
  margin-left: 15px;
  font-size: 28px;
}
.item-head {
  border-bottom: 2px #c00f31 solid;
  padding-bottom: 10px;
}
.item-head-container {
  padding: 100px 0 50px 0;
}

.item-info-title {
  font-weight: bold;
  font-size: 20px;
  margin-top: 30px;
  border-bottom: 1px #88888888 solid;
}
.item-info-subtitle {
  font-size: 15px;
  font-weight: 600;
  color: #717372;
}
.item-info {
  font-size: 12px;
  font-weight: 200;
}
.item-info-active {
  font-size: 12px;
  font-weight: 200;
  cursor: pointer;
}
.contact-bottom-container {
  margin-top: 150px;
  margin-bottom: 100px;
}
.bottom-font {
  font-size: 15px;
  margin-top: 20px;
}
.contact-col {
  justify-content: left;
  float: left;
}
</style>
